import React, { useState } from 'react';
import bg from '../../../assets/images/yzqf/xsyjbg.jpg';
import img3_2 from '../../../assets/images/yzqf/glp/3-2.png';
import img3_3 from '../../../assets/images/yzqf/glp/3-3-title.png';
import { glpdata } from './data';
import Glpitem from './Glpitem';
function XSYJ({ setType }) {
  const pagecount = 3;
  const [page, setPage] = useState(0);
  return (
    <div className="common-page animate__animated animate__fadeIn">
      <img src={bg} alt="" />
      <div className="xsyjitembox">
        {page === 0 &&
          glpdata.xsyj.slice(0, 1).map((item, index) => {
            return (
              <Glpitem item={item} index={index} cls="xsyjitem1" key={index} />
            );
          })}
        {page === 1 && (
          <img
            src={img3_2}
            alt=""
            className="img3-2  animate__animated animate__fadeIn"
          />
        )}
        {page === 2 && (
          <>
            <img
              src={img3_3}
              alt=""
              className="img3-3-title animate__animated animate__fadeIn"
            />
            {glpdata.xsyj.slice(1, 3).map((item, index) => {
              return <Glpitem item={item} index={index} key={index} />;
            })}
          </>
        )}
      </div>
      <div className="pagebox">
        <div
          className="l"
          onClick={() =>
            setPage(page - 1 < 0 ? pagecount - 1 : page - 1)
          }></div>
        <div
          className="r"
          onClick={() => setPage(page + 1 >= pagecount ? 0 : page + 1)}></div>
      </div>
      <div
        className="back"
        onClick={() => {
          setType('');
        }}></div>
    </div>
  );
}

export default XSYJ;
